module.exports = __webpack_public_path__ + "static/img/12006A_1_R_20220716_LC.f7fbd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12006A_1_R_20220716_LC.png
// module id = L/n1
// module chunks = 0